import BaseModelAPI from '../BaseModelAPI';

export default class VwPickingForDeliveryDetail extends BaseModelAPI {
	static entity = 'vwpickingfordeliveryDetail';
	static entityName = 'pickingfordelivery';

	constructor(){

	/*APP_MODEL_DEFINITION*/
    this.id = '';
    this.pickingForDeliveryId = '';
    this.pickingForDeliveryDetailId = '';
    this.deliveryInstructionId = '';
    this.deliveryInstructionParentStatusId = '';
    this.deliveryInstructionDetailId = '';
    this.deliveryInstructionDetailStatusId = '';
    this.deliveryInstructionDeliveryCardId = '';
    this.deliveryInstructionDeliveryCardPartId = '';
    this.partId = '';
    this.deliveryInstructionParentStatusCode = '';
    this.deliveryInstructionDetailStatusCode = '';
    this.deliveryInstructionDiDeliveryDate = '';
    this.pickingForDeliveryDetailPlanQty = '';
    this.pickingForDeliveryDetailActualQty = '';
    this.pickingForDeliveryDetailRemainingQty = '';
    this.pickingForDeliveryDetailRemark = '';
    this.deliveryInstructionDeliveryCardDeliveryCardNumber = '';
    this.deliveryInstructionDeliveryCardDeliveryDate = '';
    this.partPartNumber = '';
    this.partPartName = '';
            
	/*END_APP_MODEL_DEFINITION*/
	}

	static async getListVw(this_, filter, sorting, pageIndex, pageSize, persistBy) {
        let filterArray = Array();
        if (filter != null && filter != undefined) {
            // console.log(filter);
            filterArray = this.getFilter(filter);
        }
        if (sorting != null && sorting != undefined) {
            Object.entries(sorting).map(([key, value]) => { 
                if(key != '') {
                    filterArray.push("sorting[" + key +"]=" + (value ? "1" : "0"));     // draftFromUpload & draftMode
                }
            });
                
        }
        if (pageIndex != null) {
            filterArray.push("pageIndex=" + pageIndex);
        }
        if (pageSize != null) {
            filterArray.push("pageSize=" + pageSize);
        }
        let params = "";
        if (filterArray.length > 0) {
            params = "?" + filterArray.join("&");
        }
        
        //DEBUG

        return this_.$http.get(`${this.entityName}/getListVwPickingDetail` + params)
        .then(response => {
            if (response != null) {
                return response.data;
            }
            return response;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
    }
    static async getById(this_, id) {
        console.log('getById',id);
        return this_.$http.get(`${this.entityName}/getByIdVwPickingDetail/${id}`)
        .then(response => {
            if (response != null) {
                return response.data;
            }
            return response;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
    }
    static async getByIdDetailId(this_, id) {
        console.log('getById',id);
        return this_.$http.get(`${this.entityName}/getByIdVwPickingDetail/${id}`)
        .then(response => {
            if (response != null) {
                return response.data;
            }
            return response;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
    }

}